import { IProxy } from '@/features/proxies/proxySlice'
import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'

export const getProxies = async (params?: any): Promise<IApiResponse<IList<IProxy>>> => {
	const { data } = await axios.get<IApiResponse<IList<IProxy>>>('/api/proxy', { params })
	return data
}

export const updateProxy = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.put<IApiResponse<null | undefined>>('/api/proxy', params)
	return data
}

export const removeProxy = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.delete<IApiResponse<null | undefined>>('/api/proxy', { params })
	return data
}

export const addProxy = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.post<IApiResponse<null | undefined>>('/api/proxy', params)
	return data
}

export const toggleStatus = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.put<IApiResponse<null | undefined>>('/api/proxy/toggle-status', params)
	return data
}

export const getStats = async (): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.get<IApiResponse<null | undefined>>('/api/proxy/stats')
	return data
}

export const clearStats = async (): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.delete<IApiResponse<null | undefined>>('/api/proxy/stats')
	return data
}